const normalizeField = (field) => {
	if (!field || typeof field !== "object") return field;
	if (field.type === "hidden") {
		// Hidden fields are invisible: label / required / disabled don't apply.
		return { ...field, label: undefined, required: false, disabled: false };
	}
	// `required` is meaningless for select (always has a default option).
	if (field.type === "select") {
		return { ...field, required: false };
	}
	return field;
};

export const transformThirdPartyApp = (data) => {
	const rawFields = Array.isArray(data?.form_schema) ? data.form_schema : [];
	const fields = rawFields.map(normalizeField);
	return {
		...data,
		form_schema: fields,
		form_schema_enabled: Boolean(data?.form_schema_enabled && fields.length > 0),
	};
};
